import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import OffersPage from './pages/OffersPage';
import AgenciesPage from './pages/AgenciesPage';
import PackageDetailPage from './pages/PackageDetailPage';
import LoginPage from './pages/LoginPage';
import PricingPage from './pages/PricingPage';
import WaitlistPage from './pages/WaitlistPage';
import DashboardPage from './pages/admin/DashboardPage';
import PackagesPage from './pages/admin/PackagesPage';
import PackageFormPage from './pages/admin/PackageFormPage';
import AgencyProfilePage from './pages/admin/AgencyProfilePage';
import ThemePage from './pages/admin/ThemePage';
import BookingsPage from './pages/admin/BookingsPage';
import MyBookingsPage from './pages/admin/MyBookingsPage';
import QuotesPage from './pages/admin/QuotesPage';
import QuoteFormPage from './pages/admin/QuoteFormPage';
import QuoteDetailPage from './pages/admin/QuoteDetailPage';
import QuoteConvertPage from './pages/admin/QuoteConvertPage';
import ClientsPage from './pages/admin/ClientsPage';
import SocialMediaPage from './pages/admin/SocialMediaPage';
import BusinessPartnersPage from './pages/admin/BusinessPartnersPage';
import BusinessPartnerDetailsPage from './pages/admin/BusinessPartnerDetailsPage';
import BusinessPartnerPortal from './pages/admin/BusinessPartnerPortal';
import PackageClientsPage from './pages/admin/PackageClientsPage';
import NewBookingPage from './pages/admin/NewBookingPage';
import BookingFormPage from './pages/admin/BookingFormPage';
import BookingRecapPage from './pages/admin/BookingRecapPage';
import EditBookingPage from './pages/admin/EditBookingPage';
import BookingHistoryPage from './pages/admin/BookingHistoryPage';
import OAuthSuccess from './pages/admin/OAuthSuccess';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ForgetPasswordPage from './pages/ForgetPasswordPage';
import CheckEmailPage from './pages/CheckEmailPage';
import PasswordResetSuccessPage from './pages/PasswordResetSuccessPage';
import SuperAdminPage from './pages/admin/SuperAdminPage';
import WhatsAppPage from './pages/admin/WhatsAppPage';

export default function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<AgenciesPage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/HomePage" element={<Navigate to="/home" replace />} />
        <Route path="/agences" element={<AgenciesPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/waitlist" element={<WaitlistPage />} />
        <Route path="/offres" element={<OffersPage />} />
        <Route path="/package/:id" element={<PackageDetailPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/partner/:partnerId" element={<BusinessPartnerPortal />} />
        <Route path="/forgot-password" element={<ForgetPasswordPage />} />
        <Route path="/check-email" element={<CheckEmailPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/password-reset-success" element={<PasswordResetSuccessPage />} />

        {/* Admin routes */}
        <Route path="/oauth-success" element={<OAuthSuccess />} /> {/*route pour recuperer le token */}
        <Route path="/admin/dashboard" element={<DashboardPage />} />
        <Route path="/admin/packages" element={<PackagesPage />} />
        <Route path="/admin/packages/new" element={<PackageFormPage />} />
        <Route path="/admin/packages/:id" element={<PackageFormPage />} />
        <Route path="/admin/profile" element={<AgencyProfilePage />} />
        <Route path="/admin/theme" element={<ThemePage />} />
        <Route path="/admin/bookings" element={<BookingsPage />} />
        <Route path="/admin/my-bookings" element={<MyBookingsPage />} />
        <Route path="/admin/bookings/new" element={<NewBookingPage />} />
        <Route path="/admin/bookings/new/:packageId" element={<BookingFormPage />} />
        <Route path="/admin/bookings/new/:packageId/booking" element={<BookingFormPage />} />
        <Route path="/admin/bookings/edit/:id" element={<EditBookingPage />} />
        <Route path="/admin/bookings/:id/history" element={<BookingHistoryPage />} />
        <Route path="/admin/bookings/:bookingId/recap" element={<BookingRecapPage />} />
        <Route path="/admin/quotes" element={<QuotesPage />} />
        <Route path="/admin/quotes/new" element={<QuoteFormPage />} />
        <Route path="/admin/quotes/:id" element={<QuoteDetailPage />} />
        <Route path="/admin/quotes/:id/edit" element={<QuoteFormPage />} />
        <Route path="/admin/quotes/:id/convert" element={<QuoteConvertPage />} />
        <Route path="/admin/customers" element={<ClientsPage />} />
        <Route path="/admin/social" element={<SocialMediaPage />} />
        <Route path="/admin/business-partners" element={<BusinessPartnersPage />} />
        <Route path="/admin/business-partners/:partnerId" element={<BusinessPartnerDetailsPage />} />
        <Route path="/admin/packages/:packageId/clients" element={<PackageClientsPage />} />
        <Route path="/admin/whatsapp" element={<WhatsAppPage />} />
        <Route path="/superadmin" element={<SuperAdminPage />} />
      </Routes>
    </div>
  );
}